import Vue from 'vue'
import AppConfirmModal from '../components/UI/AppConfirmModal.vue'

const ConfirmModalPlugin = {
  install (Vue) {
    const ModalConstructor = Vue.extend(AppConfirmModal)

    // Crea una instancia del modal montada en el body, compartida por toda la app.
    // De esta forma se puede llamar `this.confirmModal.confirm('texto', params)` desde
    // cualquier componente y usar el resultado con `await`.
    const instance = new ModalConstructor()
    instance.$mount()
    document.body.appendChild(instance.$el)

    Vue.prototype.$confirmModal = {
      confirm (message, params) {
        return instance.open(message, params)
      }
    }

    // Aliase para que también funcione sin el signo $, como `this.confirmModal.confirm(...)`
    Vue.prototype.confirmModal = Vue.prototype.$confirmModal
  }
}

Vue.use(ConfirmModalPlugin)

export default ConfirmModalPlugin
